/**
 * ErrorDisplay Component
 * 
 * Displays error messages with optional retry functionality
 */

export default function ErrorDisplay({ 
  title = 'Error', 
  message, 
  onRetry, 
  variant = 'default' 
}) {
  const variants = {
    default: 'bg-red-50 border-red-200 text-red-800',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800'
  };

  const variantClass = variants[variant] || variants.default;

  return (
    <div className={`border rounded-lg p-6 ${variantClass}`}>
      <div className="flex items-start space-x-3">
        {/* Simple SVG warning icon */}
        <svg 
          className="h-6 w-6 flex-shrink-0" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
          />
        </svg>
        <div className="flex-1">
          <h3 className="font-semibold text-lg mb-1">{title}</h3>
          {message && (
            <p className="text-sm opacity-90 mb-3">{message}</p>
          )}
          {onRetry && (
            <button
              onClick={onRetry}
              className="px-4 py-2 bg-white border border-current rounded-lg hover:bg-opacity-90 transition-colors text-sm font-medium"
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
